/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 分析概览弹出框---公司基本信息
 */
import styles from './baseInfo.scss';
import companyPNG from '../../../../../images/company.png';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { RiskFraudType } from '../../../../../constants/enum';
import messager from '../../../../../utils/messager';
import { getPictureLink } from '../../../../../utils/util';
// import { fieldAnomaly } from '../../../../utils/formatter';
import { generateReport } from '../../../../../services/report';

export default class BaseInfo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            creating: false
        };
    }

    // 生成报告
    createReport = () => {
        const { item = {} } = this.props;

        this.setState({
            creating: true
        });
        generateReport({
            companyCode: item.companyCode,
            reportDateType: item.reportDateType,
            reportType: item.reportType,
            reportYear: item.reportYear,
            generateReportType: Object.values(RiskFraudType).reduce((a, b) => Number(a) + Number(b))
        }).then(() => {
            messager.success('报告生成完毕，请在个人中心—历史报告中查看');
        }).finally(() => {
            this.setState({
                creating: false
            });
        });
    };

    render () {
        const { item = {} } = this.props;
        const { creating } = this.state;
        return (
            <div className={classNames(styles.baseInfo, 'clearfix')}>
                <img src={companyPNG} className={styles.pic} />
                <div className={styles.info}>
                    <h2>{item.companyName || item.sesName}</h2>
                    <p className={styles.reportInfo}>{`${item.reportYear}年${item.reportDateTypeName}${item.reportTypeName}`}</p>
                    {/* <p>
                        <i className="iconfont icon-address" />公司地址：{fieldAnomaly(item.address)}
                    </p>
                    <p>
                        <i className="iconfont icon-gongsi" />公司官网：{fieldAnomaly(item.website)}
                    </p>*/}
                </div>
                <div className={styles.btns}>
                    <Link target="_blank" rel="noopener noreferrer" className="btn btn-blue" to={getPictureLink(item)}>查看画像</Link>
                    <button type="button" className="btn btn-orange" disabled={creating} onClick={this.createReport}>{creating ? '生成中...' : '生成报告'}</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/company/overviewModal/BaseInfo.jsx